
import DataHelpers from '../helpers/DataHelpers.js'
import Utilities from './Utilities.js'
import DateHelpers from '../helpers/DateHelpers'
import { dateFormats } from '../helpers/DateHelpers'



export default class {

    static log(logItem) {
        if(typeof logItem == 'undefined')
            logItem.value = null
        
        setTimeout( () => {
            let ref = DataHelpers.getTenantRef().child('log')
            logItem.stamp = DataHelpers.getStamp()
            console.log('logging change...', logItem)
            ref.push(logItem)
        },1300)

    }

    static createLogItem() {
        return {
            type: null,
            tenantKey: null,
            transactionKey: null, 
            transactionClients: null, 
            elementKey: null, 
            elementTitle: null, 
            elementIndex: null,
            value: null,
            userKey: DataHelpers.getUserId(),
            stamp: DataHelpers.getStamp(),
            result: null,
            
        }
    }

    static createListItem(logItem) {
        let item = Utilities.clone(logItem)
        let listIcon = 'email'
        let listTitle = 'Email Sent'
        if(item.result && item.result != 'OK') {
            listIcon = 'error_outline'
            listTitle = 'Failed Email'
        }

        item.meta = {...item.meta, 
                listKey: item.meta.key,
                listTitle: listTitle + ' by ' + item.stamp.firstName + ' on ' + DateHelpers.convertDate(item.stamp.date, dateFormats.BACKWARDS, 'd/M'),
                listDetails: item.stamp.time + ' ' + item.email.subject,    
                listIcon: listIcon                        
        }     
        
        return item
    }
        
}


// WEBPACK FOOTER //
// ./src/helpers/LogHelpers.js